import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getThemeTokens } from '../tokens';

export const styledMuiListItemIcon = (
  theme: Theme,
): BackstageOverrides['MuiListItemIcon'] => ({
  root: {
    color: getThemeTokens(theme).textSecondary,
    minWidth: theme.spacing(4),
  },
});
